import { FC, ReactNode, useState } from 'react';
import { CoreTooltip } from '../_core';
import { Box } from '@mui/system';
import { ClickAwayListener } from '@mui/material';

export const ProBadgeTooltip: FC<{ children: ReactNode }> = ({ children }) => {
	const [tooltipOpen, setTooltipOpen] = useState(false);

	return (
		<ClickAwayListener onClickAway={() => setTooltipOpen(false)}>
			<Box sx={{ position: 'relative', display: 'inline-flex' }}>
				<CoreTooltip
					tooltipSx={{ maxWidth: '388px', cursor: 'default' }}
					title="SweatPals Pro is our official mark of excellence — earned by hosts who consistently deliver safe, welcoming, and unforgettable experiences."
					arrow
					placement="top"
					dark
					open={tooltipOpen}
					disableFocusListener
					disableHoverListener
					disableTouchListener
				>
					<Box
						sx={{
							display: 'inline-flex',
							cursor: 'pointer',
						}}
						onClick={e => {
							e.stopPropagation();
							setTooltipOpen(true);
						}}
					>
						{children}
					</Box>
				</CoreTooltip>
			</Box>
		</ClickAwayListener>
	);
};
